import { Button } from "@/common/button";
import { EButtonType } from "@/common/button/button-models";
import { ICONS_ACCOUNT } from "@/common/icons/icons-account";
import React from "react";

export const UnlockFreeChatPopup = React.memo(
  function UnlockFreeChatPopup(props: {
    message: string;
    onConfirm: () => void;
  }) {
    return (
      <article>
        <header>
          <h1 className="text-center text-heading/[21px] font-bold text-body-text">
            Unlock Free Chat
          </h1>
        </header>

        <div className="mx-auto my-5 flex h-28 w-28 items-center justify-center rounded-full border-[3px] border-border-color">
          {ICONS_ACCOUNT.BigLock}
        </div>

        <section>
          <p className="text-center text-body-lg/[19px] font-normal text-body-text">
            {props.message ||
              "You must make at least one purchase before you can start a free chat."}
          </p>
        </section>

        <div className="mt-5">
          <Button
            type="button"
            buttonType={EButtonType.BlueWide}
            onClick={props.onConfirm}
          >
            Buy Credits
          </Button>
        </div>
      </article>
    );
  }
);
